var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCancelComision(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 48,
    width: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m24.05 32.1-3.95 3.95q-.45.45-1.05.45-.6 0-1.05-.45-.45-.45-.45-1.075T18 33.9l3.9-3.9-3.95-3.9q-.45-.45-.45-1.05 0-.6.45-1.05.45-.45 1.075-.45T20.1 24l3.9 3.85 3.9-3.9q.45-.45 1.05-.45.6 0 1.05.45.45.45.45 1.075T30 26.1L26.15 30l3.9 3.9q.45.45.45 1.05 0 .6-.45 1.05-.45.45-1.075.45T27.9 36ZM9 44q-1.2 0-2.1-.9Q6 42.2 6 41V10q0-1.2.9-2.1Q7.8 7 9 7h3.25V5.6q0-.65.475-1.125T13.85 4q.7 0 1.175.475.475.475.475 1.125V7h17V5.6q0-.65.475-1.125T34.1 4q.7 0 1.175.475.475.475.475 1.125V7H39q1.2 0 2.1.9.9.9.9 2.1v31q0 1.2-.9 2.1-.9.9-2.1.9Zm0-3h30V19.5H9V41Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelComision);
export default __webpack_public_path__ + "static/media/cancel-comision.ed38d9f8cc9c40499a07015554e5309f.svg";
export { ForwardRef as ReactComponent };